const adminRoutes = [
  { path: '/roles', name: 'roles', component: () => import(/* webpackChunkName: "roles" */ '@/pages/roles/pixRoles.vue') },
  { path: '/profiles', name: 'profiles', component: () => import(/* webpackChunkName: "profiles" */ '@/pages/profiles/pixProfiles.vue') },
  { path: '/users', name: 'users', component: () => import(/* webpackChunkName: "users" */ '@/pages/users/pixUsers.vue') },
];

export default adminRoutes;
